
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import UploadForm from "./UploadForm";
import React, { useState } from 'react';
import axios from 'axios';
import TenderDetails from "./TenderDetails";
import Tenders from "./Tenders";
import MainMenu from "./MainMenu";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import NewsTitle from "./NewsTitle";
import NewsDetails from "./NewsDetails";
import  { useEffect } from "react";

function Updates() {
   const [open, setOpen] = useState(true);
  
    // Auto collapse on mobile + auto expand on desktop
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth < 768) {
          setOpen(false); // hide on mobile
        } else {
          setOpen(true); // show on desktop
        }
      };
  
      handleResize(); // run on load
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  


  const [name, setName] = useState('');
  const [pdf, setPdf] = useState(null);
  const [message, setMessage] = useState('');

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!name || !pdf) {
      setMessage("Name and PDF file are required.");
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('pdf', pdf);

    try {
      const response = await axios.post('http://makreri.cubixsystems.com/myapp/upload.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const res = response.data;
      if (res.success) {
        setMessage("Upload successful: " + res.data.filePath);
      } else {
        setMessage("Error: " + res.message);
      }
    } catch (err) {
      console.error(err);
      setMessage("An error occurred during upload.");
    }
  };

  return (
    <div className="container-fluid p-0">
       <div
  className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
  style={{
    zIndex: 999,
    cursor: "pointer",
    position: "fixed",
    left: open ? "350px" : "60px",
    top: "0",
        transition: "left 0.3s ease"
      }}
      onClick={() => setOpen(!open)}
    >
      <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
        ☰
      </span>
    </div>

       <div className="d-flex" style={{ height: "100vh" }}>
      
              {/* LEFT SIDEBAR */}
              <div
                className="border-end leftcolor"  
                style={{
                  width: open ? "350px" : "0",
                  overflow: "hidden",
                  transition: "0.3s ease",
                 
                }}
              >
                {open && (
                  <div className="p-3">
                    <AdminLeft />
                  </div>
                )}
              </div>
      
              {/* RIGHT CONTENT */}
              <div
                className="p-4"
                style={{
                  width: open ? "calc(100% - 350px)" : "100%",
                  transition: "0.3s ease",
                  paddiingLeft:'10px'
                }}
              >
                <div>
                  <TopBanner />
                </div>
                <div className="">
                      <div className="row">
                          <div className="col-md-4">
                            <NewsTitle />
                            
                          </div>
                          <div className="col-md-8" style={{height:'100vh',overflow:'auto',paddingBottom:'100px'}}>
                            <NewsDetails />
                          </div>
                        </div>
                </div>
              </div>
      
            </div>

<div className="container">
      
        

        
     </div>
      
    </div>
  );
}


export default Updates;